import styled from 'styled-components';

export const Wrapper = styled.div<{ $dark?: boolean }>`
  max-height: 32px;
  min-height: 32px;
  display: flex;
  align-items: center;
  flex: 0;
  border-radius: 20px;
  text-align: left;
  padding: 0 5px;
  background-color: ${({ theme, $dark }) => ($dark ? theme.color.grey30 : theme.color.white)};
  color: ${({ theme, $dark }) => ($dark ? theme.color.grey : theme.color.brand_black)};
`;
